<div @fadeInAnimation>
  <div
    class="order-page-title"
    id="order-edit-top"
  >
    <eps-button
      (buttonClick)="cancelClicked()"
      *ngIf="panelStatus.backButton.isVisible"
      label="SHARED.BUTTONS.BACK"
    ></eps-button>
    <div
      *ngIf="mode.state === 'view'"
      class="content"
    >
      <div class="title">
        <app-status
          *ngIf="mode.state === 'view'"
          layout="BULLET"
          key="{{ 'ORDER_' + orderDetail.status }}"
          height="40"
          [size]="1"
        ></app-status>
        <div class="multi-line">
          <div>
            <app-title title="ORDERS.DETAILS.TITLE"></app-title>
            <span class="subtitle">{{ orderDetail.etmOrderNumber }}</span>
          </div>
          <div *ngIf="orderDetail.registeredBy">
            <span class="bold">{{ 'ORDERS.DETAILS.REGISTERED_BY' | translate }}</span>
            {{ orderDetail.registeredBy }}
          </div>
        </div>
      </div>

      <div class="action_buttons">
        <div>
          <eps-button
            (buttonClick)="createCCR()"
            *ngIf="canCreateCCR()"
            label="ORDERS.FILTER.LABELS.CREATE_CCR"
          ></eps-button>
          <eps-button
            (buttonClick)="copyOrder()"
            *ngIf="showCopyButton()"
            label="SHARED.BUTTONS.COPY"
          ></eps-button>
        </div>
      </div>
    </div>
    <app-title
      *ngIf="mode.state !== 'view' && !mode.createTemplate && !mode.editTemplate"
      title="SHARED.BUTTONS.CREATE"
      subtitle="ORDERS.DETAILS.TITLE"
    ></app-title>
    <app-title
      *ngIf="mode.state !== 'view' && (mode.createTemplate || mode.editTemplate)"
      [title]="mode.editTemplate ? 'SHARED.BUTTONS.EDIT' : 'SHARED.BUTTONS.CREATE'"
      subtitle="TEMPLATES.DETAILS.TITLE_ORDER"
    ></app-title>
  </div>

  <div class="row filter-container">
    <div class="col-12 col-md-12 col-lg-9 filter-container-inner">
      <!-- CUSTOMER -->
      <div
        class="order-create-title-bar"
        *ngIf="panelStatus.customer.blockIsVisible"
      >
        <div
          class="title-action-bar order-create-title-bar-header"
          [ngClass]="{ activated: panelStatus.customer.isEdit }"
        >
          <div class="order-create-title">
            <i
              class="fa fa-address-card"
              aria-hidden="true"
            ></i>
            <b>{{ panelStatus.customer.nr }}&nbsp;&nbsp;{{ 'ORDERS.CUSTOMER.TITLE' | translate }}</b>
            {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
          </div>
          <div
            class="edit-button"
            *ngIf="
              (panelStatus.customer.isEditable || mode.editWindow === 'delivery' || mode.editWindow === 'detail' || mode.editWindow === 'planning') &&
              !panelStatus.busy &&
              !disableButtons
            "
          >
            <eps-button
              (click)="resetCreatePage()"
              label="SHARED.BUTTONS.RESET"
            ></eps-button>
            <!--
  Disabled.  Didn't get it working correctly, and since it should clear the whole form, it's better to cancel this creation and start a new one
            <a mat-raised-button class="default" (click)="debugger">{{ 'SHARED.BUTTONS.EDIT' | translate }}</a>
  -->
          </div>
        </div>
      </div>
      <app-florder-select-customer
        [panelStatus]="panelStatus.customer"
        [customer]="orderDetail.customer"
        [customers]="customers"
        [showCancel]="isCreate()"
        (nextClicked)="setCustomer($event)"
        *ngIf="panelStatus.customer.blockIsVisible"
        (cancelClicked)="cancelClicked()"
      ></app-florder-select-customer>

      <!-- DELIVERY -->
      <div
        id="step-delivery"
        class="order-create-title-bar"
        *ngIf="panelStatus.delivery.blockIsVisible"
      >
        <div
          class="title-action-bar order-create-title-bar-header"
          [ngClass]="{ activated: panelStatus.delivery.isEdit }"
        >
          <div class="order-create-title">
            <i
              class="fa fa-truck"
              aria-hidden="true"
            ></i>
            <b>{{ panelStatus.delivery.nr }}&nbsp;&nbsp;{{ 'ORDERS.DELIVERY.TITLE' | translate }}</b>
            {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="(panelStatus.delivery.isEditable || mode.editWindow === 'detail' || mode.editWindow === 'planning') && !panelStatus.busy && !disableButtons"
            (click)="editDeliveryMethodClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
        <app-order-edit-delivery
          *ngIf="panelStatus.delivery.isVisible"
          [busy]="(busy$ | async) || false"
          [definitions]="definitions"
          [deliveryMethod]="orderDetail.deliveryMethod"
          [contractInfo]="contractInfo"
          [panelStatus]="panelStatus.delivery"
          [orderDetail]="orderDetail"
          [filterValues]="filterValues"
          [isEpsUser]="sandbox.isEpsUser$ | async"
          [defaultDepot]="sandbox.defaultDepot$ | async"
          [canSelectDepot]="sandbox.canSelectDepot$ | async"
          [busyProcess]="busyProcess$ | async"
          (cancelClicked)="cancelClicked()"
          (nextClicked)="setDeliveryMethod($event)"
          (orderTypeSelected)="loadContractInfoFromOrderTypeToIncoterm($event)"
          (fromSelected)="loadContractInfoFromOrderTypeToFrom($event)"
          (formValidChanged)="formValidChanged('delivery', $event)"
          (resetMaterialsAndPlanning)="resetMaterialsAndPlanning()"
          (emptyContract)="showEmptyContractModal()"
        ></app-order-edit-delivery>
      </div>

      <!-- ORDER DETAILS -->
      <div
        id="step-details"
        class="order-create-title-bar"
        *ngIf="panelStatus.detail.blockIsVisible"
      >
        <div
          class="title-action-bar order-create-title-bar-header"
          [ngClass]="{ activated: panelStatus.detail.isEdit }"
        >
          <div class="order-create-title">
            <i
              class="fa fa-file-o"
              aria-hidden="true"
            ></i>
            <b>{{ panelStatus.detail.nr }}&nbsp;&nbsp;{{ 'ORDERS.DETAILS.TITLE' | translate }}</b>
            {{ 'ORDERS.DETAILS.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="(panelStatus.detail.isEditable || mode.editWindow === 'planning') && !panelStatus.busy && !disableButtons"
            (click)="editDetailClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-order-edit-detail
        *ngIf="panelStatus.detail.isVisible"
        [definitions]="definitions"
        [editMaterial]="mode.material"
        [orderDetail]="orderDetail"
        [panelStatusMaterial]="panelStatus.material"
        [panelStatus]="panelStatus.detail"
        [materialTypes]="incoterm"
        (cancelClicked)="cancelClicked()"
        [loadedEpp]="loadedEpp"
        [maxEpp]="maxEpp"
        (backClicked)="backToDeliveryClicked()"
        (nextClicked)="saveDetails()"
        (saveMaterialClicked)="saveMaterial($event)"
        (removeMaterialClicked)="removeMaterial($event)"
        (startEditMaterialClicked)="editMaterial($event)"
        (formValidChanged)="formValidChanged('detail', $event)"
      ></app-order-edit-detail>

      <!-- PLANNING -->
      <div
        id="step-planning"
        class="order-create-title-bar"
        *ngIf="panelStatus.planning.blockIsVisible"
      >
        <div
          class="title-action-bar order-create-title-bar-header"
          [ngClass]="{ activated: panelStatus.planning.isEdit }"
        >
          <div
            class="order-create-title"
            *ngIf="!mode.createTemplate && !mode.editTemplate"
          >
            <i
              class="fa fa-calendar-check-o"
              aria-hidden="true"
            ></i>
            <b>{{ panelStatus.planning.nr }}&nbsp;&nbsp;{{ 'ORDERS.PLANNING.TITLE' | translate }}</b>
            {{ 'ORDERS.PLANNING.SUBTITLE' | translate }}
          </div>
          <div
            class="order-create-title"
            *ngIf="mode.createTemplate || mode.editTemplate"
          >
            <i
              class="fa fa-calendar-check-o"
              aria-hidden="true"
            ></i>
            <b>{{ panelStatus.planning.nr }}&nbsp;&nbsp;{{ 'ORDERS.NO_PLANNING.TITLE' | translate }}</b>
            {{ 'ORDERS.NO_PLANNING.SUBTITLE' | translate }}
          </div>

          <eps-button
            *ngIf="panelStatus.planning.isEditable && !panelStatus.busy"
            (click)="editPlanningClicked()"
            [disabled]="panelStatus.busy || panelStatus.planning.opening"
            [busy]="panelStatus.planning.opening"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-order-edit-planning
        *ngIf="panelStatus.planning.isVisible"
        [authorization]="authorization"
        [orderDetail]="orderDetail"
        [panelStatus]="panelStatus.planning"
        [availablePickingDates]="getAvailablePickingDates()"
        [openingHours]="getOpeningHours()"
        (cancelClicked)="cancelClicked()"
        (backClicked)="backToDetailClicked()"
        (nextClicked)="savePlanning($event)"
        (formValidChanged)="formValidChanged('planning', $event)"
      ></app-order-edit-planning>

      <!-- DOCUMENTS -->
      <div
        class="order-create-title-bar"
        *ngIf="mode.state === 'view'"
      >
        <div class="row order-create-title-bar-header">
          <div class="order-create-title">
            <i
              class="fa fa-file-text-o"
              aria-hidden="true"
            ></i>
            <b>4&nbsp;&nbsp;{{ 'ORDERS.DOCUMENTS.TITLE' | translate }}</b>
          </div>
        </div>
        <app-order-documents
          [documents]="orderDetail.documents"
          (downloadDocument)="downloadDocumentFromList($event)"
        ></app-order-documents>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-12 col-lg-9 buttons">
    <eps-button
      *ngIf="showBack$ | async"
      (buttonClick)="!disableButtons && cancel()"
      label="SHARED.BUTTONS.BACK"
    ></eps-button>
    <eps-button
      type="link"
      *ngIf="showCancel()"
      (buttonClick)="!disableButtons && cancel()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [disabled]="disableButtons || !formsAreValid.all"
      [busy]="disableButtons"
      (buttonClick)="!disableButtons && panelStatus.submitButton.isEnabled && formsAreValid.all && proceed()"
      [submit]="nextOnEnterPressed$ | async"
      *ngIf="showSubmit()"
      label="SHARED.BUTTONS.SUBMIT"
    ></eps-button>
  </div>
</div>
